import { EventCodes } from '../../../../App/model/event-codes';

(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').directive('mxWorkspaceCommonOrderPanel', function mxWorkspaceCommonOrderPanelDirective() {
		MxWorkspaceCommonOrderPanelCtrl.$inject = ['$scope', 'mx.app.DeviceService', 'mx.shell.EventService'];

		function MxWorkspaceCommonOrderPanelCtrl($scope, deviceService, eventService) {
			var vm = this;

			vm.$onInit = function () {
				vm.sortFields = vm.preprocessor.sortableColumns.map(function (column) {
					return {
						label: column.Name,
						onItemClick: function () {
							setSort(column.Name, vm.preprocessor.sortedColumns[0].Sorting);
						},
					};
				});
			};

			Object.defineProperties(vm, {
				isMobile: {
					get: function () {
						return deviceService.screenExtraSmall();
					},
				},
				direction: {
					get: function () {
						return vm.preprocessor.sortedColumns[0].Sorting === 1 ? 'asc' : 'desc'; // 1 (asc) or 2 (desc)
					},
				},
				field: {
					get: function () {
						return vm.preprocessor.sortedColumns[0].Name;
					},
					set: function (newValue) {
						setSort(newValue, vm.preprocessor.sortedColumns[0].Sorting);
					},
				},
			});

			vm.changeDirection = function () {
				setSort(vm.field, vm.direction === 'asc' ? 2 : 1);
			};

			function setSort(field, sorting) {
				const sortOptions = [
					{
						name: field,
						sorting: sorting,
						priority: 0,
					},
				];
				vm.preprocessor.setSort(sortOptions);

				eventService.dispatchEvent(EventCodes.TrackTelemetry, {
					eventName: `Data sorted`,
					sender: vm.preprocessor.parameters.id,
					senderTitle: vm.preprocessor.parameters.name,
					contextTypeId: vm.preprocessor.parameters.entities.map((entity) => entity.id),
					contextTypeTitle: vm.preprocessor.parameters.entities.map((entity) => entity.name),
					contextId: sortOptions,
				});
			}

			return vm;
		}

		return {
			restrict: 'E',
			scope: {},
			bindToController: { preprocessor: '<' },
			controller: MxWorkspaceCommonOrderPanelCtrl,
			controllerAs: 'vm',
			templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-datasource-order-panel/mx-datasource-order-panel.html',
		};
	});
})();
